import { th } from 'style/theme';
import styled from 'styled-components';

export const Text = styled.div`
  display: flex;
  color: ${th('colors.turquoise')};
  flex-direction: row;
  gap: 4px;
  padding-left: 2px;
`;
